import { render, staticRenderFns } from "./MultiSelectField.vue?vue&type=template&id=2205b0f5&"
import script from "./MultiSelectField.vue?vue&type=script&lang=js&"
export * from "./MultiSelectField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports